export default __webpack_public_path__ + "static/media/step1.7a1dbb5f.png";